import React, { useEffect, useState } from "react";
import { Table, Button, Space, Modal, Form, Input, message } from "antd";
import { useSelector } from "react-redux";

const Inventory = () => {
  const user = useSelector((state) => state.user.user);

  return <>Inventory View</>;
};

export default Inventory;
